import gql from "graphql-tag";

export class Login {
  /**
   * Get a auth code form a application
   */
  async getAuthCode({ appCode, apolloClient }) {
    const {
      data: {
        getAuthCode: { authCode }
      }
    } = await apolloClient.query({
      query: gql`query getauthcode {
        getAuthCode(appCode: "${appCode}") {
          authCode: code
        }
      }`
    });

    return authCode;
  }

  /**
   * Login by auth code which form another application
   */
  async loginByAuthCode({ apolloClient, authCode }) {
    let {
      data: { userInfo }
    } = await apolloClient.query({
      query: gql`
        query loginByAuthCode($authCode: String!) {
          userInfo: loginByAuthCode(authCode: $authCode) {
            authToken: userAuthToken
            userCode
            email
            firstName
            lastName
            mobile
            orgCode
            userType
            passwordSet
            tenantCode
            tenantName
          }
        }
      `,
      variables: {
        authCode
      }
    });

    return userInfo;
  }
}
